<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="38" height="38" rx="7" ry="7"
      fill="none"
      :stroke="color"
      stroke-width="2"
    />
    <circle
      v-for="(pip, i) in pips[value] || []"
      :key="i"
      :cx="pip[0]"
      :cy="pip[1]"
      r="3.5"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  value: { type: Number, required: true },
  size:  { type: Number, default: 32 },
  color: { type: String, default: 'currentColor' },
})

// Pip positions on a 40x40 grid
const pips = {
  1: [[20, 20]],
  2: [[12, 12], [28, 28]],
  3: [[12, 12], [20, 20], [28, 28]],
  4: [[12, 12], [28, 12], [12, 28], [28, 28]],
  5: [[12, 12], [28, 12], [20, 20], [12, 28], [28, 28]],
  6: [[12, 10], [28, 10], [12, 20], [28, 20], [12, 30], [28, 30]],
}
</script>
